import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 500,
      color: palette.text.primary,
      borderSpacing: '15px 15px',
      width: '100%',
      '@media (max-width: 720px)': {
        borderSpacing: '10px 10px'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
